let tabButtons = document.querySelectorAll('.product_tab .tb-hdngs button');
let tabContents = document.querySelectorAll('.product_tab .tab-content');

tabButtons[0]?.classList.add('is_active');
tabContents[0]?.classList.add('is_active');

tabButtons.forEach((button,index)=>{
    button.addEventListener('click',()=>{
      let otherButtons = document.querySelectorAll('.tb-hdngs button');
      otherButtons.forEach((otherBtns)=>otherBtns.classList.remove('is_active'))
      tabContents.forEach((content)=>content.classList.remove('is_active'))
       button.classList.add('is_active');
      tabContents[index].classList.add('is_active');
    })
}) 


//product tab script

let questions = document.querySelectorAll('.product_tab_container .content h2')

questions.forEach((q,i) => {
  const a = q.nextElementSibling;
  q.addEventListener('click', () => {
    q.classList.toggle('active')
    a.classList.toggle('acitve')
   let maxHt = a.style.maxHeight ? null :  a.scrollHeight + 'px'
    a.style.maxHeight = maxHt;
  });
});
